import { uiRows } from './types-def.js';
/** `web/trash` (1.V-2): trashed documents. */
export const TRASH_INTERACTIONS = uiRows([
    {
        id: 'trash.restore.document',
        module: 'web/trash',
        behavior: 'Restoring a document from the Trash brings it back with its links, and it leaves the Trash',
        owner: '1.V-2',
        since: 'exit-1a',
    },
]);
//# sourceMappingURL=trash.js.map